/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <Card>
    <Toolbar>
      <v-toolbar-title class="fs-16">{{ $t('Plant Alerts') }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </Toolbar>
    <v-layout row wrap>
      <v-flex xs6 sm6 md6 lg12>
        <div class="text-xs-right pa-2">
          <v-btn-toggle slot="activator" mandatory>
            <v-btn color="success" v-on:click="download">{{ $t('Download') }}</v-btn>
          </v-btn-toggle>
        </div>
      </v-flex>
    </v-layout>
    <div class="pa-2 text-xs-right card--height">
      <v-select
        v-model="alertSelection"
        :items="selections"
        hide-details
        single-line
        :label="$t('Select an alert')"
        class="ml-2 mr-2">
      </v-select>
      <v-progress-circular indeterminate color="primary" v-show="loading"></v-progress-circular>
      <v-list v-show="items.length > 0" class="list-content-height">
        <template v-for="(item, index) in items">
          <v-list-tile :key="item" avatar ripple>
            <v-list-tile-content>
              <v-list-tile-title @click="redirectAlert(item,index)"> {{ getPlantName(item) }} </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider v-if="index + 1 < items.length" :key="index"></v-divider>
        </template>
      </v-list>
    <div class="text-xs-center" v-show="items.length === 0">
      {{ computedMessage }}
    </div>
    </div>
  </Card>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Doughnut from './doughnut'
import { mixin } from '@/util/mixin/index'
import AlertService from '@/services/Alert'

export default {
  components: {
    Doughnut
  },
  data() {
    return {
      param: {
        plantList: []
      },
      alertSelection: null,
      selections: [{
        text: 'Data logger communication',
        value: {
          equipment: 'gateway'
        }
      },
      {
        text: 'Inverter',
        value: {
          equipment: 'inverter'
        }
      },
      {
        text: 'MFM',
        value: {
          equipment: 'mfm'
        }
      },
      {
        text: 'WS',
        value: {
          equipment: 'ws'
        }
      },
      {
        text: 'Low PR',
        value: {
          code: 'low_pr'
        }
      },
      {
        text: 'Low String',
        value: {
          code: 'string_underperforming'
        }
      }
      ],
      items: [],
      alertitems: [],
      loading: false,
      message: 'Please select an option'
    }
  },
  props: ['theme'],
  mixins: [mixin],
  computed: {
    ...mapGetters([
      'getTotalGeneration',
      'getPlantTotalGeneration',
      'getTheme',
      'getPlantIdList',
      'getPlantName',
      'isV2'
    ]),
    computedMessage() {
      return this.$t(this.message)
    },
    carbonColor() {
      return this.getTheme ? '#7fff00' : '#66CD00'
    },
    carbonEmission() {
      return {
        co2: this.getPlantTotalGeneration * 0.0008,
        diesel: this.getPlantTotalGeneration * 0.069,
        treeSaved: this.getPlantTotalGeneration * 0.012,
        houseLighted: this.getPlantTotalGeneration * 0.0001
      }
    }
  },
  watch: {
    alertSelection() {
      this.items = []
      this.alertitems = []
      this.loading = true
      AlertService.getActiveAlert({
        plantList: this.getPlantIdList,
        query: this.alertSelection
      }).then(result => {
        console.log('Result data:', result.data.message[0])
        this.items = result.data.message[0]
        this.alertitems = result.data.message[1]
        if (this.items.length === 0) { this.message = 'No Data' }
        this.loading = false
      }).catch(err => {
        this.message = 'There was some error while loading the data. Please try again!!'
        this.loading = false
      })
    }
  },
  methods: {
    ...mapMutations([
      'setSelectedPlantId',
      'setIsAlertRedirected',
      'setSelectedAlert'
    ]),

    redirectAlert(plantId, index) {
      console.log('check', plantId, this.alertSelection.equipment)
      this.setSelectedPlantId(plantId)
      this.setIsAlertRedirected(true)
      this.setSelectedAlert(this.alertSelection.equipment)
      this.$router.push('/alert')
    },

    download: async function () {
      // console.log("ENtering the data",this.items, this.alertitems);
      this.JSONToCSVConvertor(this.items, this.alertitems)
    },
    convertUnix(unixtimestamp) {
    // Months array
      var months_arr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      // Convert timestamp to milliseconds
      var date = new Date(unixtimestamp * 1000)
      // Year
      var year = date.getFullYear()
      // Month
      var month = months_arr[date.getMonth()]
      // Day
      var day = date.getDate()
      // Hours
      var hours = date.getHours()
      // Minutes
      var minutes = '0' + date.getMinutes()
      // Seconds
      var seconds = '0' + date.getSeconds()
      // Display date time in MM-dd-yyyy h:m:s format
      var convdataTime = month + '-' + day + '-' + year + ' ' + hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2)

      return convdataTime
    },
    JSONToCSVConvertor: function (plant, time) {
      // If plant is not an object then JSON.parse will parse the JSON string in an Object
      var arrDataplant = typeof plant !== 'object' ? JSON.parse(plant) : plant
      var arrDatatime = typeof time !== 'object' ? JSON.parse(time) : time
      var CSV = ''
      // Set Report title in first row or line

      let header = 'Plant Name, Datetime'
      let row = ''

      CSV += header + '\r\n'

      for (var i = 0; i < arrDataplant.length; i++) {
        let row = ''
        let planName = this.getPlantName(arrDataplant[i])
        let dateTime = this.convertUnix(arrDatatime[i])
        row += '"' + planName + '",' + dateTime
        CSV += row + '\r\n'
      }
      console.log('ENtering the data', CSV)

      if (CSV === '') {
        alert('Invalid data')
        return
      }

      // Generate a file name
      var fileName = ''
      fileName += 'Plants Alert Report'.replace(/ /g, '_')

      var uri = 'data:text/csv;charset=utf-8,' + escape(CSV)

      var link = document.createElement('a')
      link.href = uri

      link.style = 'visibility:hidden'
      link.download = fileName + '.csv'

      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>

<style scoped>
.v-toolbar {
  height: 44px;
}

.theme--dark .v-card {
  background-color: #242c50;
}

.card--height{
    height: calc(100vh - 310px);
}

.list-content-height {
    max-height: calc(388px - 68px);
    overflow-y: auto;
}

.theme--dark .v-list, .application .theme--dark.v-list {
  background-color: #242c50;
  color: white;
}

.right-space {
  margin-right: 10px;
}
</style>
<style lang="stylus" scoped>
  .v-progress-circular
    margin: 1rem
</style>
